const getPriceInfo = ({
  basic = false,
  currency,
  planPriceInfo,
}) => {
  const isGbp = currency === 'gbp';
  if (basic || !planPriceInfo) {
    return {
      smallestPrice: 0,
      largestPrice: 0,
    };
  }

  const sortedPlanPriceInfo = [...planPriceInfo].sort((a, b) => a.price - b.price);
  const smallestPrice = sortedPlanPriceInfo[0];
  const largestPrice = sortedPlanPriceInfo.at(-1);

  return {
    smallestPrice: isGbp ? smallestPrice.price_gbp : smallestPrice.price,
    largestPrice: isGbp ? largestPrice.price_gbp : largestPrice.price,
  };
};

export default getPriceInfo;
